import { AudioLines } from 'lucide-react'
import { resolveTtsPermissions } from 'v2/pages/voice-studio/permissions'
import { VOICE_STUDIO_TABS } from 'v2/pages/voice-studio/tabs'
import { createLazyComponent } from 'v2/shared/utils/lazy-utils'
import { type IRoute, SidebarGroups } from 'v2/types'
import type { RFeatureFlags, UserRole } from 'v2/types/api/auth'
import type { ModulePermissionTypeMap } from 'v2/types/rbac'

const VoiceStudio = createLazyComponent(() => import('v2/pages/voice-studio'))

/**
 * One sidebar entry in the `build` group; the five product tabs plus Metrics are in-page,
 * backed by hidden child routes so each is deep-linkable (plan §5, AGENTS.md failure mode 47 —
 * a new sidebar GROUP would need two `packages/neo` edits, which this deliberately avoids).
 */
export const getVoiceStudioRoutes = (meta?: {
  featureFlags?: RFeatureFlags
  roles?: UserRole[]
  permissionsMap?: ModulePermissionTypeMap
  location?: string
}): IRoute[] => {
  const closed =
    !meta?.featureFlags?.voiceStudioEnabled || !resolveTtsPermissions(meta?.permissionsMap).canView

  return [
    {
      title: 'Voice Studio',
      path: '/voice-studio',
      icon: <AudioLines size={16} />,
      component: <VoiceStudio />,
      hidden: closed,
      notAllowed: closed,
      sidebar: {
        group: SidebarGroups.build,
      },
      children: VOICE_STUDIO_TABS.map((tab) => ({
        title: `Voice Studio - ${tab.label}`,
        path: `/voice-studio/${tab.key}`,
        component: <VoiceStudio />,
        hidden: true,
        notAllowed: closed,
      })),
    },
  ]
}
